import { ContextStore } from 'bernie-plugin-mobx';
import { inject } from 'mobx-react';
import * as React from 'react';

import { MultiItemStore } from 'src/common/stores/multi-item-store';
import { SearchResultsStore } from 'src/common/stores/search-results-store';
import { UIPageStore } from 'src/common/stores/ui-page-store';

import { Results } from './results';
import { SearchErrorMessageWrapper } from '../search-error-message';

interface SearchResultsWrapperProps {
  searchResults?: SearchResultsStore;
  context?: ContextStore;
  uiPage?: UIPageStore;
  multiItem?: MultiItemStore;
}

export const SearchResultsWrapper: React.FC<SearchResultsWrapperProps> = inject(
  'searchResults',
  'context',
  'uiPage',
  'multiItem'
)(({ searchResults, context, uiPage, multiItem }) => {
  if (!uiPage || !searchResults) return null;
  const { searchCriteria } = searchResults;

  const similarDestinationProps = multiItem?.isPackageShoppingPath()
    ? null
    : { inputs: { collectionId: 'similar_destinations' }, pageContext: { propertySearch: searchCriteria, context } };

  const renderErrorMessage = () => <SearchErrorMessageWrapper />;

  return <Results errorMessage={renderErrorMessage()} similarDestinationProps={similarDestinationProps} />;
});
